import { OmitType, PartialType } from '../../../../utils';
import { CreatePartnersAgencyDto } from './create-partners-agency.dto';
export class UpdatePartnersAgencyDto extends PartialType(OmitType(CreatePartnersAgencyDto, ['name'])) {
}
